module.exports = __webpack_public_path__ + "img/bg_6.b40c26fe.png";